import React from 'react';

import cn from 'classnames';

import { useIsSidebarOpen } from '@shared/hooks';
import { Icon } from '@shared/ui/Icon';
import { UiButton } from '@shared/ui/UiButton';
import { UiText } from '@shared/ui/UiText';

import cls from './ConversationBanner.module.css';
import { ConversationClientModal } from '../../../features/ConversationClientModal/ui/ConversationClientModal';
import { useConversationBanner } from '../lib/hooks/useConversationBanner';
import { useScrollConversationBanner } from '../lib/hooks/useScrollConversationBanner';

interface ConversationBannerProps {
    classes?: string;
}

export const ConversationBanner = ({ classes }: ConversationBannerProps) => {
    const { isSidebarOpen, sidebarWidth } = useIsSidebarOpen();
    const topOffset = useScrollConversationBanner();

    const {
        isOpenBanner,
        ref,
        onReadMore,
        onCloseBanner,
        isOpen,
        closeClientModal,
        onSendSurvey,
        t,
    } = useConversationBanner();

    return (
        <>
            {isOpenBanner && (
                <div
                    ref={ref}
                    className={cls.bannerWrapper}
                    style={{
                        top: `${topOffset}px`,
                        ...(isSidebarOpen
                            ? {
                                  left: `${sidebarWidth}px`,
                                  width: `calc(100% - ${sidebarWidth}px)`,
                              }
                            : {}),
                    }}
                >
                    <div className={cn(cls.ConversationBanner, [classes])}>
                        <UiText tag="span" classes={cls.title}>
                            {/* @ts-ignore */}
                            {bannerData.title}
                        </UiText>
                        <UiButton
                            className={cls.button}
                            onClick={onReadMore}
                            variant="text"
                            btnText={t('ConversationBanner.readMore.btn.text')}
                            endIcon={<Icon iconName="rightArrow" />}
                        />
                        <UiButton
                            className={cls.close}
                            onClick={onCloseBanner}
                            variant="icon"
                            startIcon={<Icon iconName="close" />}
                        />
                    </div>
                </div>
            )}
            {isOpen && (
                <ConversationClientModal close={closeClientModal} onSendSurvey={onSendSurvey} />
            )}
        </>
    );
};
